export * from './lib/page-title.module';
export * from './lib/page-title.token';
export * from './lib/page-title.resolver';
